import React from 'react';
import AccessibleModal from './AccessibleModal';
import Button from './Button';
import Icon from '../AppIcon';

const CelebrationModal = ({
  isOpen,
  onClose,
  title = 'Congratulations!',
  message,
  achievementType = 'goal', // 'goal', 'debt', 'savings', 'budget', 'habit'
  achievementDetails = null,
  nextGoalSuggestion = null,
  onShare = null
}) => {
  const achievementIcons = {
    goal: 'Target',
    debt: 'TrendingDown',
    savings: 'PiggyBank',
    budget: 'DollarSign',
    habit: 'CheckCircle'
  };

  const achievementColors = {
    goal: 'var(--color-success)',
    debt: 'var(--color-primary)',
    savings: 'var(--color-warning)',
    budget: 'var(--color-success)',
    habit: 'var(--color-primary)'
  };

  return (
    <AccessibleModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="small"
      closeOnOverlayClick={true}
    >
      <div className="space-y-6">
        {/* Achievement Badge */}
        <div className="flex flex-col items-center">
          <div className="relative">
            <div className="flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-success/20 to-primary/20 border-4 border-success/30 animate-pulse">
              <Icon
                name={achievementIcons?.[achievementType] || 'Award'}
                size={48}
                color={achievementColors?.[achievementType]}
                strokeWidth={2}
              />
            </div>
            {/* Sparkle effect */}
            <div className="absolute -top-2 -right-2 text-2xl animate-bounce">✨</div>
            <div className="absolute -bottom-2 -left-2 text-2xl animate-bounce" style={{ animationDelay: '0.2s' }}>🎉</div>
          </div>
        </div>

        {/* Congratulatory Message */}
        <div className="text-center space-y-2">
          <p className="text-lg text-foreground font-semibold">{message}</p>
          {achievementDetails && (
            <div className="bg-success/10 rounded-lg p-4 border border-success/20">
              <div className="space-y-1">
                {Object.entries(achievementDetails)?.map(([key, value]) => (
                  <div key={key} className="flex justify-between items-center">
                    <span className="text-sm text-muted-foreground capitalize">{key}:</span>
                    <span className="text-sm text-foreground font-medium">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Next Goal Suggestion */}
        {nextGoalSuggestion && (
          <div className="bg-primary/10 rounded-lg p-4 border border-primary/20">
            <div className="flex items-start gap-3">
              <Icon name="Lightbulb" size={20} color="var(--color-primary)" strokeWidth={2} />
              <div className="flex-1">
                <p className="text-sm font-medium text-foreground mb-1">What's Next?</p>
                <p className="text-sm text-muted-foreground">{nextGoalSuggestion}</p>
              </div>
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3">
          {onShare && (
            <Button
              onClick={onShare}
              variant="outline"
              fullWidth
              iconName="Share2"
              iconPosition="left"
            >
              Share Achievement
            </Button>
          )}
          <Button
            onClick={onClose}
            variant="default"
            fullWidth
          >
            Continue
          </Button>
        </div>
      </div>
    </AccessibleModal>
  );
};

export default CelebrationModal;